export default __webpack_public_path__ + "static/media/Inter-Medium.f5549f68.woff";